import { render, staticRenderFns } from "./LeaveBalanceTable.vue?vue&type=template&id=644ae249&"
import script from "./LeaveBalanceTable.vue?vue&type=script&lang=js&"
export * from "./LeaveBalanceTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalanceTable.vue?vue&type=style&index=0&id=644ae249&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports